<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid remove-z-index mt-0">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="row m-0 p-0">
          <div class="col-11" id="multiselectDiv" *ngIf="!isVisible">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
              <p-multiSelect [filter]="true" [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStatuses"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" id="multiselectStatuses" placeholder="Sel. Status"
                [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1" id="refreshBatchesDiv">
            <button pButton class="refreshBatches" *ngIf="checkProcessFlowProperties()" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv" [hidden]="isVisible">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Protocol"></button>
              <p-multiSelect [options]="protocolsList" name="processFlowsList" (onChange)="onApplyFilter()"
                [(ngModel)]="selectedProtocolList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" id="multiselectStatuses"
                placeholder="Sel. Protocol" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1 pt-2" id="refreshBatchesDiv">
            <button pButton class="refreshBatches resetButton" icon="pi pi-times" (click)="resetAllFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv" *ngIf="!isVisible">
            <div class="ui-inputgroup" id="datePicker">
              <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
              <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()">
              </p-calendar>
            </div>
          </div>
          <div class="col-1 pt-2"></div>
          <div class="flex justify-content-between px-0">
            <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
              <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
            </span>
            <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
          </div>
        </div>

      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">

          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" id="puid-field" class="inputFileds"/>
            </div>
            <div class="ui-inputgroup" id="inputClass" [(ngModel)]="plateBtn1">
              <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10"
                (keydown.enter)="searchForPlate()" class="inputFileds"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForPlate()"></button>
            </div>
            <div class="ui-inputgroup" id="inputClass" [(ngModel)]="plateBtn1">
              <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
              <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10"
                (keydown.enter)="searchForSample()" class="inputFileds"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForSample()"></button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align:left;">
            <div class="col-12 flex headers">
              <h5>
                Plate: <strong>{{getPlateValue()}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers statusField" id="headerNonTop">
              <h5>
                Status: <strong> {{selectedPlate?.status}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" id="headerNonTop">
              <h5>
                Sender:<strong> {{selectedPlate?.sender}}</strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Sample-Type: <strong> {{selectedPlate?.sampleType}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" id="headerNonTop" style="margin-top:-14px" *ngIf="selectedPlate?.storagePlate">
              <h5>
                Storage:<strong> {{selectedPlate?.storage}}</strong>
              </h5>
            </div>
          </div>

          <div class="col-3 topDivspacing p-0">
            <div class="ui-inputgroup pl-0" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="History"></button>

              <p-dropdown
                [options]="plateHistory" [(ngModel)]="plateHistoryId" placeholder="Select a Plate"
                [style]="{'width':'auto','height':'35px'}">
              </p-dropdown>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-5 p-0">
                <button pButton icon="pi pi-list" [label]="getPlateViewButtonLabel(isVisible)" *ngIf="(plateBtn1 === 'enabeledd' || plateBtn ==='enabeled') && !this.multiPlate"
                (click)="tableVisible()" class="buttonsRoundResponsive" id="plateView">
                  </button>
              </div>
              <div class="col-5 p-0">
                <button pButton icon="fa fa-comment" label="Comments" *ngIf="(plateBtn1 === 'enabeledd' || plateBtn ==='enabeled') && !this.multiPlate"
                (click)="showComments()" class="buttonsRoundResponsive" id="plateView">
                  </button>
              </div>
              <div class="col-6 p-0">
                <button pButton icon="fa fa-comment" label="Comments" *ngIf="lastUpdatedPlates1.length>0 && this.multiPlate"
                (click)="showMultiComments()" class="buttonsRoundResponsive" id="plateView">
                  </button>
              </div>
            </div>
            <div style="height: 50px" class="col-12 flex p-0 ui-inputgroup">
              <input #manualfileUpload pInputText class="form-control" name="profile" type="file"
                accept=".log" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload Log Files"
                #fileInput />
              <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                (click)="fileUpload()" [disabled]="isFileNotSelected" class="uploadBtn">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class = "tableLHS1">
          <p-table [value]="plates" selectionMode="single" [(selection)]="tableSelectedRow" (onRowSelect)="fetchPlate($event)" (onRowUnselect)="removePlateSelection()" [(ngModel)]="plateBtn" name="allPlates" ngDefaultControl [loading]="loading">
            <ng-template pTemplate="header">
              <tr style="border: 1px solid lightgray;">
                <th scope="col" class="batch">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
                <th scope="col" class="status">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plate>
              <tr [pSelectableRow]="plate">
                <td style="width: 30%; border: 1px solid lightgray;" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody text-break pr-0">
                    <span>{{getPlateDisplayValue(plate)}}</span>
                    <i *ngIf="plate?.latestUserComment" class="pi pi-comment p-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                    <i class="pi pi-star-fill" *ngIf="plate?.reRun"></i>
                    <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i>
                  <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
                </td>
                <td style="width: 75%; border: 1px solid lightgray;" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody pr-0" >
                  {{plate?.status}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-9">
        <div class="col-6" id="tableDiv" *ngIf="!plateViewSelectionDone">
          <table aria-describedby="Workflow selection" id="workflowSelection"
            style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
            <thead id="processingTableHeader">
              <tr>
                <th scope="col">Workflow Selection</th>
              </tr>
            </thead>
            <tbody id="processingTableBody">
              <tr>
                <td id="processingTableBody" style="height: 12rem;">
                  <div class="col-12 parent">
                    <div class="col-12">
                      <div class="col-1">
                      </div>
                      <div class="col-11">
                        <span style="font-size: 1.5em;">Please enter the Plate-ID with which you want to continue!</span>
                      </div>
                    </div>
                    <div class="col-12 flex">
                      <div class="col-2"></div>
                      <div class="col-8">
                        <div class="ui-inputgroup">
                          <button type="button" pButton class="LHButton1" label="Plate ID"></button>
                          <input pInputText id="input" [(ngModel)]="plateToSearch" class="SearchBox1 p-2" size="30"
                            (keydown.enter)="workflowSelection()"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--View for  older flow-->
        <div class="col-12 flex" id="tableDiv" [hidden]="showPlateView"
          *ngIf="plateViewSelectionDone && !isVisible && processStepViewDecider('OLD_FLOW')">
          <div class="col-12 flex" id="tableDiv">
            <table aria-describedby="Processing table" id="processingTable"
              style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
              <thead id="processingTableHeader">
                <tr>
                  <th scope="col">Amplify WGA</th>
                  <th scope="col">Recombine DNA</th>
                  <th scope="col">Precipitate DNA</th>
                  <th scope="col">Last Updated</th>
                </tr>
              </thead>
              <tbody id="processingTableBody">
                <tr>

                  <td id="processingTableBody">

                    <div class="col-12 flex parent">
                      <div class="col-10 flex">
                        <div class="col-4 childLH">
                          <button type="button" pButton class="LHbutton " label="Liquid Handler"></button>
                        </div>
                        <div class="col-6 child2">
                          <input pInputText id="input" [(ngModel)]="amplifyLiquidHandler"
                            [value]="getProcessStepLiquidHandler('AMPLIFY_WGA')"
                            [disabled]="disableButton(0, 'AMPLIFY_WGA', '', 0)" class="SearchBox p-2" size="30" />
                        </div>
                      </div>
                      <div class="col-2 child">
                        <button type="button" (click)="showChemicalPopup('AMPLIFY_WGA')" pButton
                          class="buttonsRound1 downLoadButton" label="LOT"></button>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start WGA" (click)="savePlateStatus('START_PREPCR', 0, 'AMPLIFY_WGA', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'AMPLIFY_WGA', '', 0)">
                        </button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('AMPLIFY_WGA')">
                        {{getProcessStepStartTimestamp('AMPLIFY_WGA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('AMPLIFY_WGA')}}
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Incubate WGA 37°C"
                          (click)="savePlateStatus('INCUBATE_WGA_37C',2, 'AMPLIFY_WGA', 'INCUBATE_WGA_37C', 0)"
                          class="buttonsRound VioletButtons"
                          [disabled]="disableButton(2, 'AMPLIFY_WGA', 'INCUBATE_WGA_37C', 0)">
                        </button>
                      </div>
                      <div class="col-4 child action-timer-div"
                        *ngIf="isValidProcessStepAction('AMPLIFY_WGA', 'INCUBATE_WGA_37C')">
                        <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'INCUBATE_WGA_37C')}}
                        </span>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete WGA" (click)="savePlateStatus('WGA_COMPLETED',1, 'AMPLIFY_WGA', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'AMPLIFY_WGA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('AMPLIFY_WGA')">
                        {{getProcessStepEndTimestamp('AMPLIFY_WGA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepEndPuid('AMPLIFY_WGA')}}
                      </div>

                    </div>
                  </td>

                  <td id="processingTableBody">

                    <div class="col-12 flex parent">
                      <div class="col-10 flex">
                        <div class="col-4 childLH">
                          <button type="button" pButton class="LHbutton " label="Liquid Handler"></button>
                        </div>
                        <div class="col-6 child2">
                          <input pInputText id="input" [(ngModel)]="recombineLiquidHandler"
                            [value]="getProcessStepLiquidHandler('RECOMBINE_DNA')"
                            [disabled]="disableButton(0, 'RECOMBINE_DNA', '', 0)" class="SearchBox p-2" size="30" />
                        </div>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Recombine"
                          (click)="savePlateStatus('RECOMBINING_STARTED',0, 'RECOMBINE_DNA', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'RECOMBINE_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('RECOMBINE_DNA')">
                        {{getProcessStepStartTimestamp('RECOMBINE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('RECOMBINE_DNA')}}
                      </div>
                    </div>


                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Recombine"
                          (click)="savePlateStatus('RECOMBINING_COMPLETED',1, 'RECOMBINE_DNA', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'RECOMBINE_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('RECOMBINE_DNA')">
                        {{getProcessStepEndTimestamp('RECOMBINE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepEndPuid('RECOMBINE_DNA')}}
                      </div>
                    </div>

                    <div class="col-12 grid parent">
                      <div class="col-8 child">
                        <button pButton label="Store PGX Plate" (click)="savePlateStatus('PGX_PLATE_STORED',0, 'STORE_PGX_PLATE', '', 0)"
                          class="buttonsRound otherbutton" [disabled]="disableButton(0, 'STORE_PGX_PLATE', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('STORE_PGX_PLATE')">
                        {{getProcessStepStartTimestamp('STORE_PGX_PLATE') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('STORE_PGX_PLATE')}}
                      </div>
                      <div class="col-8 child">
                        <p-dropdown placeholder="Select Storage Location" [options]="recombineDnaStorageList" optionLabel="storageName"
                          optionValue="storageName" name="recombineDnaStorageList" [(ngModel)]="selectedStorage"
                          [disabled]="disableButton(0, 'STORE_PGX_PLATE', '', 0)"
                          *ngIf="recombineDnaStorageList.length > 1" [style]="{'width':'165px'}">
                        </p-dropdown>
                      </div>
                    </div>
                  </td>

                  <td id="processingTableBody">

                    <div class="col-12 flex parent">
                      <div class="col-10 flex">
                        <div class="col-4 childLH">
                          <button type="button" pButton class="LHbutton " label="Liquid Handler"></button>
                        </div>
                        <div class="col-6 child2">
                          <input pInputText id="input" [(ngModel)]="precipitateLiquidHandler"
                            [value]="getProcessStepLiquidHandler('PRECIPITATE_DNA')"
                            [disabled]="disableButton(0, 'PRECIPITATE_DNA', '', 0)" class="SearchBox p-2" size="30" />
                        </div>
                      </div>
                      <div class="col-2 child">
                        <button type="button" (click)="showChemicalPopup('PRECIPITATE_DNA')" pButton
                          class="buttonsRound1 downLoadButton" label="LOT"></button>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Precipitation"
                          (click)="savePlateStatus('PRECIPITATION_STARTED',0, 'PRECIPITATE_DNA', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'PRECIPITATE_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('PRECIPITATE_DNA')">
                        {{getProcessStepStartTimestamp('PRECIPITATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('PRECIPITATE_DNA')}}
                      </div>
                    </div>


                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Centrifuge" class="buttonsRound VioletButtons"
                          (click)="savePlateStatus('CENTRIFUGE',2, 'PRECIPITATE_DNA', 'CENTRIFUGE', 0)"
                          [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'CENTRIFUGE', 0)"></button>
                      </div>
                      <div class="col-4 child action-timer-div"
                        *ngIf="isValidProcessStepAction('PRECIPITATE_DNA', 'CENTRIFUGE')">
                        <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'CENTRIFUGE')}}
                        </span>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Max Drying Time" class="buttonsRound VioletButtons"
                          (click)="savePlateStatus('MAX_DRYING_TIME',2, 'PRECIPITATE_DNA', 'MAX_DRYING_TIME', 1)"
                          [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'MAX_DRYING_TIME', 1)"></button>
                      </div>
                      <div class="col-4 child action-timer-div"
                        *ngIf="isValidProcessStepAction('PRECIPITATE_DNA', 'MAX_DRYING_TIME')">
                        <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA',
                          'MAX_DRYING_TIME')}} </span>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Precipit."
                          (click)="savePlateStatus('PRECIPITATION_COMPLETED',1, 'PRECIPITATE_DNA', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'PRECIPITATE_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('PRECIPITATE_DNA')">
                        {{getProcessStepEndTimestamp('PRECIPITATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepEndPuid('PRECIPITATE_DNA')}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Safe Stopping" (click)="savePlateStatus('PRECIPITATE_WGA_PLATE_STORED',0, 'PRECIPITATE_SAFE_STOPPING', '', 0)"
                        [disabled]="disableButton(0, 'PRECIPITATE_SAFE_STOPPING', '', 0) || disableButton(0, 'RESUSPEND_DNA', '', 0)"
                          class="buttonsRound otherbutton"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('PRECIPITATE_SAFE_STOPPING')">
                        {{getProcessStepStartTimestamp('PRECIPITATE_SAFE_STOPPING') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('PRECIPITATE_SAFE_STOPPING')}}
                      </div>
                      <div class="col-8 child pt-2 pb-2">
                        <p-dropdown placeholder="Select Storage Location" [options]="precipitateDnaStorageList" optionLabel="storageName"
                          optionValue="storageName" name="precipitateDnaStorageList" [(ngModel)]="selectedStorage"
                          [disabled]="disableButton(0, 'PRECIPITATE_SAFE_STOPPING', '', 0) || disableButton(0, 'RESUSPEND_DNA', '', 0)"
                         *ngIf="precipitateDnaStorageList.length > 1" [style]="{'width':'165px'}">
                        </p-dropdown>
                      </div>
                    </div>
                  </td>

                  <td rowspan="3" id="processingTableBody">
                    <table class="last-updated-table">
                      <tr *ngFor="let updatedPlate of lastUpdatedPlates1; let i=index">
                        <td>{{updatedPlate.plateId}}</td>
                        <td>{{lastUpdatedPlates2[i].plateId}}</td>
                        <td>{{lastUpdatedPlates3[i].plateId}}</td>
                      </tr>
                      <tr>
                    </table>
                  </td>
                </tr>

                <tr id="processingTableHeader">
                  <th class="secondHeader" scope="col">Amplify PGx</th>
                  <th class="secondHeader" scope="col">Fragment DNA</th>
                  <th class="secondHeader" scope="col">Resuspend DNA</th>
                </tr>

                <tr>
                  <td id="processingTableBody">

                    <div class="col-12 flex parent">
                      <div class="col-2 child1">
                        <button type="button" (click)="showChemicalPopup('AMPLIFY_PGX')" pButton
                          class="buttonsRound1 downLoadButton" label="LOT"></button>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start PGx" (click)="savePlateStatus('START_PREPCR',0, 'AMPLIFY_PGX', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'AMPLIFY_PGX', '', 0)">
                        </button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('AMPLIFY_PGX')">
                        {{getProcessStepStartTimestamp('AMPLIFY_PGX') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('AMPLIFY_PGX')}}
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Run Thermo Cycler"
                          (click)="savePlateStatus('RUN_THERMO_CYCLER',2, 'AMPLIFY_PGX', 'RUN_THERMO_CYCLER', 0)"
                          class="buttonsRound VioletButtons"
                          [disabled]="disableButton(2, 'AMPLIFY_PGX', 'RUN_THERMO_CYCLER', 0)"></button>
                      </div>
                      <div class="col-4 child action-timer-div"
                        *ngIf="isValidProcessStepAction('AMPLIFY_PGX', 'RUN_THERMO_CYCLER')">
                        <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_PGX', 'RUN_THERMO_CYCLER')}}
                        </span>
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete PGx" (click)="savePlateStatus('PGX_COMPLETED',1, 'AMPLIFY_PGX', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'AMPLIFY_PGX', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('AMPLIFY_PGX')">
                        {{getProcessStepEndTimestamp('AMPLIFY_PGX') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepEndPuid('AMPLIFY_PGX')}}
                      </div>
                    </div>
                  </td>
                  <td id="processingTableBody">

                    <div class="col-12 flex parent">
                      <div class="col-2 child1">
                        <button type="button" (click)="showChemicalPopup('FRAGMENT_DNA')" pButton
                          class="buttonsRound1 downLoadButton" label="LOT"></button>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Fragmen."
                          (click)="savePlateStatus('FRAGMENTATION_STARTED',0, 'FRAGMENT_DNA', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'FRAGMENT_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('FRAGMENT_DNA')">
                        {{getProcessStepStartTimestamp('FRAGMENT_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('FRAGMENT_DNA')}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Incubate 37°C"
                          (click)="savePlateStatus('INCUBATE_37C',2, 'FRAGMENT_DNA', 'INCUBATE_37C', 0)"
                          class="buttonsRound VioletButtons" [disabled]="disableButton(2, 'FRAGMENT_DNA', 'INCUBATE_37C', 0)">
                        </button>
                      </div>
                      <div class="col-4 child action-timer-div"
                        *ngIf="isValidProcessStepAction('FRAGMENT_DNA', 'INCUBATE_37C')">
                        <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'INCUBATE_37C')}}
                        </span>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Fragmen."
                          (click)="savePlateStatus('FRAGMENTATION_COMPLETED',1, 'FRAGMENT_DNA', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'FRAGMENT_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('FRAGMENT_DNA')">
                        {{getProcessStepEndTimestamp('FRAGMENT_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepEndPuid('FRAGMENT_DNA')}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Safe Stopping" (click)="savePlateStatus('FRAGMENT_WGA_PLATE_STORED',0, 'FRAGMENT_SAFE_STOPPING', '', 0)"
                        [disabled]="disableButton(0, 'FRAGMENT_SAFE_STOPPING', '', 0) || disableButton(0, 'PRECIPITATE_DNA', '', 0)"
                          class="buttonsRound otherbutton"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('FRAGMENT_SAFE_STOPPING')">
                        {{getProcessStepStartTimestamp('FRAGMENT_SAFE_STOPPING') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('FRAGMENT_SAFE_STOPPING')}}
                      </div>
                      <div class="col-8 child pt-2 pb-2">
                        <p-dropdown placeholder="Select Storage Location" [options]="fragmentDnaStorageList" optionLabel="storageName"
                          optionValue="storageName" name="fragmentDnaStorageList" [(ngModel)]="selectedStorage"
                          [disabled]="disableButton(0, 'FRAGMENT_SAFE_STOPPING', '', 0) || disableButton(0, 'PRECIPITATE_DNA', '', 0)"
                          *ngIf="fragmentDnaStorageList.length > 1" [style]="{'width':'165px'}">
                        </p-dropdown>
                      </div>
                    </div>
                  </td>
                  <td id="processingTableBody">

                    <div class="col-12 flex parent">
                      <div class="col-10 flex">
                        <div class="col-4 childLH">
                          <button type="button" pButton class="LHbutton " label="Liquid Handler"></button>
                        </div>
                        <div class="col-6 child2">
                          <input pInputText id="input" [(ngModel)]="resuspendLiquidHandler"
                            [value]="getProcessStepLiquidHandler('RESUSPEND_DNA')"
                            [disabled]="disableButton(0, 'RESUSPEND_DNA', '', 0)" class="SearchBox p-2" size="30" />
                        </div>
                      </div>
                      <div class="col-2 child">
                        <button type="button" (click)="showChemicalPopup('RESUSPEND_DNA')" pButton
                          class="buttonsRound1 downLoadButton" label="LOT"></button>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Resus."
                          (click)="savePlateStatus('RESUSPENDING_STARTED',0, 'RESUSPEND_DNA', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'RESUSPEND_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('RESUSPEND_DNA')">
                        {{getProcessStepStartTimestamp('RESUSPEND_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('RESUSPEND_DNA')}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Incubation 58°C "
                          (click)="savePlateStatus('INCUBATION_58C',2, 'RESUSPEND_DNA', 'INCUBATION_58C', 0)"
                          class="buttonsRound VioletButtons"
                          [disabled]="disableButton(2, 'RESUSPEND_DNA', 'INCUBATION_58C', 0)">
                        </button>
                      </div>
                      <div class="col-4 child action-timer-div"
                        *ngIf="isValidProcessStepAction('RESUSPEND_DNA', 'INCUBATION_58C')">
                        <span class="action-timer-span">{{calculateRemainingTimeForAction('RESUSPEND_DNA', 'INCUBATION_58C')}}
                        </span>
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Resus."
                          (click)="savePlateStatus('RESUSPENDING_COMPLETED',1, 'RESUSPEND_DNA', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'RESUSPEND_DNA', '', 0)"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('RESUSPEND_DNA')">
                        {{getProcessStepEndTimestamp('RESUSPEND_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepEndPuid('RESUSPEND_DNA')}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Safe Stopping" (click)="savePlateStatus('RESUSPEND_WGA_PLATE_STORED',0, 'RESUSPEND_SAFE_STOPPING', '', 0)"
                        [disabled]="disableButton(0, 'RESUSPEND_SAFE_STOPPING', '', 0)"
                          class="buttonsRound otherbutton"></button>
                      </div>
                      <div class="col-5 sibling" *ngIf="isValidProcessStep('RESUSPEND_SAFE_STOPPING')">
                        {{getProcessStepStartTimestamp('RESUSPEND_SAFE_STOPPING') | date: 'dd.MM.yy HH:mm'}} <br />
                        {{getProcessStepStartPuid('RESUSPEND_SAFE_STOPPING')}}
                      </div>
                      <div class="col-8 child pt-2 pb-2">
                        <p-dropdown placeholder="Select Storage Location" [options]="resuspendDnaStorageList" optionLabel="storageName"
                          optionValue="storageName" name="resuspendDnaStorageList" [(ngModel)]="selectedStorage"
                          *ngIf="resuspendDnaStorageList.length > 1" [style]="{'width':'165px'}">
                        </p-dropdown>
                      </div>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--View for axiom 384 plate-->
        <div class="col-12 flex" id="tableDiv" [hidden]="showPlateView" *ngIf="plateViewSelectionDone && !isVisible && processStepViewDecider('AXIOM_384')">
          <app-ma-plate-preparation-axiom [multiPlate]="multiPlate" [selectedPlate]="selectedPlate" [selectedPlateStepsMap]="selectedPlateStepsMap" [selectedPlateProcessFlow]="selectedProcessFlow"
           (reloadPlateTableEmitter)="onApplyFilter()" (updatePlateDataEmitter)="updatePlateData($event)" (plateViewResetEmitter)="plateViewSelectionDone=false"></app-ma-plate-preparation-axiom>
        </div>

        <div class="col-12 flex p-0" *ngIf="isVisible">
          <div class="col-6 p-0">
            <p-radioButton name="redoGroup" value='PlateView' label="View Plates" [(ngModel)]="typeOfView"></p-radioButton>
          </div>
          <div class="col-6 p-0">
            <p-radioButton name="redoGroup" value='BeadchipView' label="BeadChip" [(ngModel)]="typeOfView"></p-radioButton>
          </div>
        </div>

        <div class="col-12 flex p-0" *ngIf="typeOfView === 'BeadchipView' && isVisible && viewType == 'AXIOM_384'">
          <app-ma-beadchip-view [selectedBeadchipData]="beadChipDetails"></app-ma-beadchip-view>
        </div>

        <div class="col-12 flex p-0" *ngIf="typeOfView === 'BeadchipView' && isVisible && viewType == 'OLD_FLOW'">
          <div class="col-5">
            <h5 class="headerStyle">
              BeadChip1-ID:
              <strong style="color:rgb(235, 144, 6); font-size: 1.3rem; margin-left: 1%">{{getBeadchipAt(0)}} </strong>
            </h5>
            <table id="scanTable" aria-describedby="BeadChip" class="table" style="table-layout: auto;">
              <thead>
                <tr class="row100 head">
                  <th class="column100 column1" scope="col"></th>
                  <th class="column100 column2 td-padding" scope="col" *ngFor="let col of BcolumnHeaders; let k = index">
                    {{col}} </th>
                </tr>
              </thead>

              <tbody>
                <tr class="row100" *ngFor="let row of BrowHeaders; let i = index;">
                  <td class="column100 column1">{{row}}</td>
                  <td class="column100 column2 td-padding" *ngFor="let col  of BcolumnHeaders; let j = index">
                    <input class="cellviewsold1" pInputText type="text" readonly  [value]="getBeadchipSampleAt(i, j, beadchipSamplesMap, 0).sampleID"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-5 pl-4">
            <h5 class="headerStyle">
              BeadChip2-ID:
              <strong style="color:rgb(235, 144, 6); font-size: 1.3rem; margin-left: 1%">{{getBeadchipAt(1)}} </strong>
            </h5>
            <table id="scanTable" aria-describedby="BeadChip" class="table" style="table-layout: auto;">
              <thead>
                <tr class="row100 head">
                  <th class="column100 column1" scope="col"></th>
                  <th class="column100 column2 td-padding" scope="col" *ngFor="let col of BcolumnHeaders; let k = index">
                    {{col}} </th>
                </tr>
              </thead>

              <tbody>
                <tr class="row100" *ngFor="let row of BrowHeaders; let i = index;">
                  <td class="column100 column1">{{row}}</td>
                  <td class="column100 column2 td-padding" *ngFor="let col of BcolumnHeaders; let j = index">
                    <input class="cellviewsold1" pInputText type="text" readonly  [value]="getBeadchipSampleAt(i, j, beadchipSamplesMap, 1).sampleID"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-2 sample-redo-button-padding">
            <button pButton class="theme-button noHover labelButton1" type="button" label="Sample Redo"></button>
          </div>
        </div>

        <div style="display: flex; flex-direction: column;" class="col-12" *ngIf="typeOfView === 'PlateView' && isVisible">
          <div style="height: 70 px;" class="col-12 flex headers">
            <h5 class="headerStyle">
              Plate-ID:
              <strong style="color:rgb(235, 144, 6); font-size: 1.3rem; margin-left: 1%">{{selectedPlate?.plateID}} </strong>
            </h5>
          </div>
          <table style="margin-top: 2%;" id="scanTable" aria-describedby="View Plates" class="table">
            <thead>
              <tr class="row100 head">
                <th class="column100 column1" scope="col"></th>
                <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index">
                  {{col}} </th>
              </tr>
            </thead>

            <tbody>
              <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
                <td class="column100 column1">{{row}}</td>
                <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%;">
                  <input class="cellviewsold" pInputText type="text" [value]="getSampleAt(i, j, plateMap).sampleID" readonly />
                </td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>
</div>


<p-dialog header="Multiple Plates Update" [(visible)]="showConfirmPlatesPopup" showEffect="fade" position="top"
    [modal]="true" [style]="{width: '350px'}" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup()">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View Plates" class="table">
        <tr>
          <input pInputText style="padding: 2.5%;" name="plateId" [(ngModel)]="enteredPlateId" id="popup-plateid" (keydown.enter)="checkPlate()"
            [placeholder]="multiUpdateInputLabel" />
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateList;">
          <input pInputText style="padding: 2.5%;" name="plateId" [value]="plate"  id="plateid" readonly />
          <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteValue(index)"></button>
        </tr>
      </table>
    </div>
    <div>
      <p-dropdown placeholder="Select Storage Location" [options]="recombineDnaStorageList" optionLabel="storageName" optionValue="storageName" [style]="{'width':'215px','margin-left':'1.1rem', 'margin-bottom':'1rem','display':'flex'}"
        name="storageList" [(ngModel)]="selectedStorage" *ngIf="multiUpdateStatusLabel=='Store PGX Plate'">
      </p-dropdown>
      <p-dropdown placeholder="Select Storage Location" [options]="precipitateDnaStorageList" optionLabel="storageName" optionValue="storageName" [style]="{'width':'215px','margin-left':'1.1rem', 'margin-bottom':'1rem','display':'flex'}"
        name="storageList" [(ngModel)]="selectedStorage" *ngIf="multiUpdateStatusLabel=='Store WGA Plate Precipitate'">
      </p-dropdown>
      <p-dropdown placeholder="Select Storage Location" [options]="resuspendDnaStorageList" optionLabel="storageName" optionValue="storageName" [style]="{'width':'215px','margin-left':'1.1rem', 'margin-bottom':'1rem','display':'flex'}"
        name="storageList" [(ngModel)]="selectedStorage" *ngIf="multiUpdateStatusLabel=='Store WGA Plate Resuspend'">
      </p-dropdown>
      <p-dropdown placeholder="Select Storage Location" [options]="fragmentDnaStorageList" optionLabel="storageName" optionValue="storageName" [style]="{'width':'215px','margin-left':'1.1rem', 'margin-bottom':'1rem','display':'flex'}"
        name="storageList" [(ngModel)]="selectedStorage" *ngIf=" multiUpdateStatusLabel=='Store WGA Plate Fragment'">
      </p-dropdown>
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdatePlateList.length ==0">
      </button>
    </div>
</p-dialog>


<p-dialog header="Multiple Plates Update" [(visible)]="showConfirmPlatesPopupForRecombine" showEffect="fade" position="top"
    [modal]="true" [style]="{width:'600px'}" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup()">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View Plates" class="table">
        <tr>
          <input pInputText class="input-text-padding" [(ngModel)]="enteredWGAPlateId" id="wgaPlateid"
            placeholder="Scan WGA PlateId" (keydown.enter)="checkforPGXPlate()"/>
            <input pInputText class="input-text-padding" [(ngModel)]="enteredPGXPlateId" id="pgxPlateID" (keydown.enter)="checkPGXPlate()"
              [placeholder]="pgxPlateIDPlaceHolder"/>
        </tr>
        <tr *ngFor="let plate of multiPlateUpdateListForRecombine;">
          <input pInputText class="input-text-padding" [value]="plate.wgaPlateID"  id="plateid" readonly/>
          <input pInputText class="input-text-padding" [value]="plate.pgxPlateID"  id="plateid" readonly/>
          <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteItem(index)"></button>
        </tr>
      </table>
    </div>
    <div>
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiPlateUpdateListForRecombine.length ==0">
      </button>
    </div>
</p-dialog>

<p-dialog header="Multiple Plates Update" [(visible)]="showStartWGAorPGXMultiPlateUpdate" showEffect="fade" position="top"
    [modal]="true" [style]="{width: '850px'}" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup()">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View Plates" class="table">
        <tr>
          <input class="input-text-padding" pInputText name="plateId" [(ngModel)]="enteredPlateId" id="source-plate-id" (keydown.enter)="checkPlate()" (focusout)="checkPlate()"
            placeholder="Scan Source Plate" />
          <input class="input-text-padding" pInputText name="plateId" [(ngModel)]="enteredWgaPlateId" id="wga-plate-id" (keydown.enter)="checkWgaPlateID()" (focusout)="checkWgaPlateID()"
            placeholder="Scan WGA Plate" />
          <input class="input-text-padding" pInputText name="plateId" [(ngModel)]="enteredPgxPlateId" id="pgx-plate-id" (keydown.enter)="checkPgxPlateID()" (focusout)="checkPgxPlateID()"
            placeholder="Scan PGx Plate" />
        </tr>
        <tr *ngFor="let plateUpdateInfo of multiUpdatePlateInfoList;">
          <input pInputText class="input-text-padding" name="plateId" [value]="plateUpdateInfo.plateID"  id="plateid" readonly />
          <input pInputText class="input-text-padding" name="plateId" [value]="plateUpdateInfo.wgaPlateID"  id="plateid" readonly />
          <input pInputText class="input-text-padding" name="plateId" [value]="plateUpdateInfo.pgxPlateID"  id="plateid" readonly />
          <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteRow(index)"></button>
        </tr>
      </table>
    </div>
    <div>
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdatePlateInfoList.length==0">
      </button>
    </div>
</p-dialog>

<p-dialog header="Chemicals" [(visible)]="showDialogue" [focusOnShow]="true" [modal]="true" [style.width]="'800px'" position="top" (onHide)="hideChemicalDialog(selectedPlate)">
  <app-ma-chemicals-popup [selectedPlate]="selectedPlate" [selectedBeadChip]="null" [selectedProcessStep]="selectedProcessStep" [processStepChemicals]="processStepChemicals" [noChemicalEdit]="noChemicalEdit"
    [multiChemicals]="multiChemicalEdit" [plateids]="chemicalsPlateids" [isPlate]="true" [dialogOpen]="showDialogue" (backButtonEmitter)="hideChemicalDialog($event)"></app-ma-chemicals-popup>
</p-dialog>

<p-dialog header="Add Comments" [(visible)]="showMultipleCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <div class="col-12 flex" id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..." [(ngModel)]="newMultiComment"></textarea>
  </div>
  <div class="col-12 flex mt-2 addCommentButton">
    <button pButton label="Add Comment" [disabled]="(newMultiComment == null || newMultiComment.trim() == '')" (click)="saveMultiComment()"></button>
  </div>
</p-dialog>

<p-dialog header="{{selectedPlate.plateID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <app-ma-comments-popup [selectedPlateID]="selectedPlateID" [selectedPlateStatus]="selectedPlateStatus"  [plateCommentList] = "plateCommentsList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" (backButtonEmitter)="hideDialog($event)"></app-ma-comments-popup>
</p-dialog>
